<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      d="M16 10L12.1257 13.8743C12.0563 13.9437 11.9437 13.9437 11.8743 13.8743L8 10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
